// Takes date format of YYYY-MM-DD, returns eg: Wednesday 15th Jan 2020
export default function (value) {


	// TODO: CHECK IS A VALID ISO DATE STRING


	if (value) {
		function dayOrdinalSuffix(i) {
			var j = i % 10;
			var k = i % 100;
			if (j == 1 && k != 11) {
				return "st";
			}
			if (j == 2 && k != 12) {
				return "nd";
			}
			if (j == 3 && k != 13) {
				return "rd";
			}
			return "th";
		}
		var year = value.substring(0, 4);
		var month = value.substring(5, 7)-1;
		var day = value.substring(8, 10);
		var hour = value.substring(11, 13);
		var minute = value.substring(14, 16);
		var second = value.substring(17, 19);
		var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
		var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];

		if (hour) {
			// Use parseInt on day so that eg: the 2nd doesn't appear as 02nd
			var dateTime = new Date(year, month, day, hour, minute, second);
			// Use parseInt on day so that eg: the 2nd doesn't appear as 02nd
			return days[dateTime.getDay()]+' '+parseInt(day)+dayOrdinalSuffix(day)+' '+months[dateTime.getMonth()]+' '+hour+':'+minute+':'+second;
		} else {
			var dateTime = new Date(year, month, day);
			// Use parseInt on day so that eg: the 2nd doesn't appear as 02nd
			return days[dateTime.getDay()]+' '+parseInt(day)+dayOrdinalSuffix(day)+' '+months[month]+' '+year;
		}
	} else {
		return '';
	}
}
